import BqnContext from "common/BqnContext";
import { useContext } from "react";
import styled from "styled-components";

const BqnButton = styled.button`
  span {
    top: 0px !important;
    margin-left: 0px !important;
    line-height: 30px;
  }
  &.btn-default.active {
    background-color: var(--subtitle-color) !important;
    color: var(--Text-Inverted) !important;
    span {
      font-weight: bold;
    }
  }

  &.btn-default.active:hover {
    background-color: var(--subtitle-color) !important;
    color: var(--Text-Inverted) !important;
    span {
      font-weight: bold;
    }
  }
`;

const BqnButtonsContainer = styled.div`
  display: flex;
  gap: 7px;
  margin-bottom: 7px;
  flex-wrap: wrap;
  margin-top: -15px;
`;

export const BqnTabs = ({ value, showAll = true }) => {
  const {
    setBqnId,
    bqns,
    clusterStatus: { mode },
  } = useContext(BqnContext);

  if (mode === "standalone" || value === null || value === undefined) {
    return null;
  }

  return (
    <div className="container-lg">
      <div className="row clearfix">
        <BqnButtonsContainer className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          {showAll && (
            <BqnButton
              type="button"
              className={`btn btn-default waves-effect shadow-none${
                "all" === value.toString() ? " active" : ""
              }`}
              onClick={() => setBqnId("all")}
              key="all"
            >
              <span>All</span>
            </BqnButton>
          )}
          {bqns.map(({ bqnId: bqn, function: _function }) => (
            <BqnButton
              type="button"
              className={`btn btn-default waves-effect shadow-none${
                bqn.toString() === value.toString() ? " active" : ""
              }`}
              onClick={() => setBqnId(bqn)}
              disabled={_function === "offline"}
              key={bqn}
            >
              <span>BQN {bqn}</span>
            </BqnButton>
          ))}
        </BqnButtonsContainer>
      </div>
    </div>
  );
};
